import { withLDProvider } from 'launchdarkly-react-client-sdk'

const getClientSideLaunchDarklyId = () => {
  if (typeof window === 'undefined') return '6239ed6851ae021505e5b99a'
  switch (window.ENV) {
    case 'prod':
      return '6239ed6851ae021505e5b99b'
    case 'staging':
      return '624f3eb12013891525c35ddb'
    default:
      return '6239ed6851ae021505e5b99a'
  }
}

export const withLDConfig = () => withLDProvider({ clientSideID: getClientSideLaunchDarklyId() })
